import { useQueryClient } from '@tanstack/react-query';
import { getExchangeRate } from '../../../api/v2/load';

export const useExchangeRates = (currencyOptions) => {
  const queryClient = useQueryClient();

  const fetchExchangeRate = async (currencyId, date) => {
    if (!currencyOptions?.length || !currencyId) return null;

    const currencyCode = currencyOptions.find((c) => c.id === currencyId?.toString())?.data;

    if (!currencyCode) {
      return null;
    }

    if (currencyCode === 'GBP') {
      return 1;
    }

    return await queryClient.fetchQuery({
      queryKey: ['getExchangeRate', currencyCode, date.toString()],
      queryFn: async () => {
        // only pass loading date to the backend if it is not the current month
        const todaysDate = new Date();
        const convertedLoadingDate = new Date(date);
        const getCurrentRate = convertedLoadingDate.getMonth() >= todaysDate.getMonth();

        const [data] = await getExchangeRate(currencyCode, getCurrentRate ? null : date);
        return data?.rate || null;
      },
      staleTime: Infinity,
    });
  };

  return { fetchExchangeRate };
};
